import React, { useEffect, useState, useRef } from 'react';
import classnames from 'classnames';
import { getIncomeSource } from '@/utils/vip';
import { getSkuType, handleTheme } from '@/utils';
import { TabType } from '@/constants/subscription';
import Copywriting from './components/copywriting';
import UserinfoModule from './components/userinfo';
import ProductList from './components/product-list';
import ProductListUnlimited from './components/product-list-unlimited';
import ProductPay from './components/product-pay';
import ExchangeModule from './components/exchange';
import PayResult from './components/pay-result';
import BindPhone from './components/bind-phone';
import { track } from '@/utils/common';
import { useAtom } from 'jotai';
import {
  activeIndexAtom,
  curProductAtom,
  curTabAtom,
  productsAtom,
  seatsAtom,
  visibleBindPhoneAtom,
  visibleResultAtom,
} from '@/store';
import {
  clearPollTimer,
  getProducts,
  handleRefreshQrCode,
  initActiveProductIndex,
  initFn,
} from '@/utils/subscribe';

import styles from './index.module.css';
import { SubscribeType, subscribeType } from '@/constants';

const Vip = () => {
  const [, setActiveIndex] = useAtom(activeIndexAtom);
  const [products, setProducts] = useAtom(productsAtom);
  const [curProduct] = useAtom(curProductAtom);
  const [curTab, setCurTab] = useAtom(curTabAtom);
  const [visibleResult] = useAtom(visibleResultAtom);
  const [seats] = useAtom(seatsAtom);
  const [visibleBindPhone] = useAtom(visibleBindPhoneAtom);
  const [hasInited, setHasInited] = useState<boolean>(false);

  useEffect(() => {
    handleTheme();
    initFn(() => {
      setHasInited(true);
    });

    return () => {
      // 页面销毁时，清除定时器
      clearPollTimer();
    };
  }, []);

  useEffect(() => {
    if (products.length) {
      // 初始话商品默认选中状态
      initActiveProductIndex();
    }
  }, [products]);

  useEffect(() => {
    // 切换商品、切换席位数，需要重新刷新支付二维码
    if (curProduct) {
      handleRefreshQrCode();
    }
  }, [curProduct, seats]);

  useEffect(() => {
    if (hasInited) {
      setProducts([]);
      setActiveIndex(-1);
      getProducts();
    }

    // web订阅触发页面进入事件，切换tab也需要重新上报
    if (getIncomeSource() === 'MTXX-WEB') {
      track({
        event_id: 'vip_page_enter',
        params: {
          sku_type: getSkuType(),
        },
      });
    }
  }, [curTab]);

  const messageHandler = (e: any) => {
    let data = e.data || (e.originalEvent && e.originalEvent.data);
    if (typeof data === 'string' && /^[\[\{]/.test(data)) {
      data = JSON.parse(data);
    }

    if (data && data.action === 'viewSubscription') {
      // 修改URL上的entrance参数值
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.set('entrance', 'retention_popup');
      window.history.replaceState({}, '', url);
      // 切换成购买会员
      setCurTab(TabType.SUB);

      track({
        event_id: 'vip_page_enter',
        params: {},
      });
    }
  };

  useEffect(() => {
    window.addEventListener('message', messageHandler, false);
    return () => {
      window.removeEventListener('message', messageHandler, false);
    };
  }, []);

  const renderProductModule = () => (
    <div className={styles.purchaseModule}>
      <div
        className={classnames(styles.left, {
          [styles.leftBgTransparent]: subscribeType === SubscribeType.LOGO_UNLIMITED,
        })}
      >
        {subscribeType === SubscribeType.LOGO_UNLIMITED ? (
          <ProductListUnlimited />
        ) : (
          <>
            <ProductList />
            <Copywriting />
          </>
        )}
      </div>

      <div className={styles.right}>
        <ProductPay />
      </div>
    </div>
  );

  return (
    <div
      className={styles.main}
      style={{
        borderRadius: getIncomeSource() !== 'MTXX-WEB' ? 0 : '',
        width: getIncomeSource() !== 'MTXX-WEB' ? '100%' : '',
        height: getIncomeSource() !== 'MTXX-WEB' ? '100%' : '',
      }}
    >
      <UserinfoModule />
      <div className={classnames(styles.content, 'contentBox')}>
        {renderProductModule()}
        <ExchangeModule />
      </div>
      {visibleResult ? <PayResult theme={'light'} /> : null}
      {visibleBindPhone ? <BindPhone /> : null}
    </div>
  );
};

export default Vip;
